import { useQueryClient } from '@tanstack/react-query'
import type { UserProfile } from '@/features/settings/types'

const DEFAULT_ITEMS_PER_PAGE = 25

/**
 * Read the user's "items_per_page" preference from the profile query cache.
 *
 * This is a lightweight accessor — it does NOT fetch the profile.
 * The profile is already fetched by `useProfile()` (called in pages that need it,
 * e.g. Queue, Settings). Other pages get the cached value if available,
 * or fall back to the default (25).
 *
 * Usage:
 *   const itemsPerPage = useItemsPerPage()
 */
export function useItemsPerPage(): number {
  const qc = useQueryClient()
  const profile = qc.getQueryData<UserProfile>(['settings', 'profile'])
  return profile?.preferences?.items_per_page ?? DEFAULT_ITEMS_PER_PAGE
}
